import axios from 'axios'
import { getToken, getCustomer, setRemoteVersion, logout, getVendedorId } from './auth'
import urlAPI, { urlApiArquivos, urlApiReports } from './urlAPI'

export const api = axios.create({
  baseURL: urlAPI() + '/api',
  timeout: 120000
})

api.interceptors.request.use(function (config) {
  const token = getToken()
  const Customer = getCustomer()

  if (token) config.headers.Authorization = `Bearer ${token}`
  if (Customer) config.headers.Customer = Customer

  return config

})

api.interceptors.response.use(
  response => {
    /* Em caso de erro de autenticação, retorna para a tela de login */
    if (response.status === 511) logout()

    /* Salva a versão atual do console no storage */
    if (response.headers['version-app'])
      setRemoteVersion(response.headers['version-app'])

    /* Retorna a requisição em caso de sucesso */
    return response
  },
  error => {
    /* Em caso de erro de autenticação, retorna para a tela de login */
    if (error.response) {
      if (error.response.status === 511) logout()
      if (error.response.status === 401) logout()
    }

    return Promise.reject(error)
  }
)


/********** API de arquivos *************/
export const apiArquivos = axios.create({
	baseURL: urlApiArquivos() + '/api',
	timeout: 120000
})

apiArquivos.interceptors.request.use(function (config) {

	/* Inclui o token na requisição */
	const token = getToken();
	if (token) config.headers.Authorization = `Bearer ${token}`

	const vendedor = getVendedorId()
	if (vendedor) config.headers.Customer = getCustomer();

	return config;
});

/********** API REPORTS *************/
export const apiReports = axios.create({
	baseURL: urlApiReports(),
	timeout: 120000
})